"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicRoutes = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const PublicRoutes = ({ routes }) => {
    return (react_1.default.createElement(react_router_dom_1.Switch, null, routes.map(({ component: Component, path, exact }) => (react_1.default.createElement(react_router_dom_1.Route, { path: `/${path}`, key: path, exact: exact, component: Component })))));
};
exports.PublicRoutes = PublicRoutes;
